module.exports = __webpack_public_path__ + "static/media/model-mission-20.774cb669.png";